import { useCallback, useMemo } from 'react'

import { createRef } from 'react'

import { useDispatch } from 'react-redux'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import { useNotifications } from '@app/hooks'
import { dismissNotification } from '@app/store/notifications'

import { Toast } from './Toast'
import styles from './styles.module.scss'
import { ToasterProps } from './types'

const classNames = {
  enter: styles['toastsTransition-enter'],
  enterActive: styles['toastsTransition-enter-active'],
  exit: styles['toastsTransition-exit'],
  exitActive: styles['toastsTransition-exit-active'],
}

export const Toaster = ({
  transitionEnterTimeout = 600,
  transitionLeaveTimeout = 600,
}: ToasterProps) => {
  const { notifications } = useNotifications()
  const dispatch = useDispatch()
  const dismiss = useCallback(
    (id: string) => {
      dispatch(dismissNotification(id))
    },
    [dispatch]
  )

  const transitionTimeout = useMemo(() => {
    return {
      enter: transitionEnterTimeout,
      exit: transitionLeaveTimeout,
    }
  }, [transitionEnterTimeout, transitionLeaveTimeout])

  return (
    <div className={styles.toastsContainer}>
      <TransitionGroup>
        {notifications.map((notification) => {
          const nodeRef = createRef<HTMLDivElement>()
          return (
            <CSSTransition
              key={notification.id}
              nodeRef={nodeRef}
              timeout={transitionTimeout}
              classNames={classNames}
            >
              <div ref={nodeRef}>
                <Toast notification={notification} dismiss={dismiss} />
              </div>
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </div>
  )
}
